const SecurityRelevantFiles = {
    NotAllowedExtensionList: ['.exe', '.js', '.json', '.dll', '.ps1', '.bat', '.iso', '.img', '.vhd', '.msi']
};

export default SecurityRelevantFiles;